import React from 'react';
import { Box } from '@mui/material';
import logo from '../assets/logo.png';

export default function BrandLogo({
  width = 150,
  height = 56,
}) {
  return (
    <Box
      component="img"
      src={logo}
      alt="Zypio Logo"
      sx={{
        width,
        height,
        objectFit: 'contain',
        display: 'block',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderRadius: 0,
        p: 0,
        m: 0,
      }}
    />
  );
}